import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import axios from "axios";
import AuthService from "./services/auth";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import MaterialDashboard from "./material-dashboard";

// Initialize auth state before mounting the app
store.dispatch("auth/initializeAuth");

// Setup axios interceptor for token refresh
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Handle 401 Unauthorized errors
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        console.log("🔄 Received 401, attempting token refresh...");
        const newToken = await AuthService.refreshAccessToken();
        console.log("✅ Token refreshed successfully");

        // Update authorization header with new token
        originalRequest.headers.Authorization = `Bearer ${newToken}`;

        // Retry original request
        return axios(originalRequest);
      } catch (refreshError) {
        console.error("❌ Token refresh failed, logging out...");
        AuthService.logout();
        router.push({ name: "SignIn" });
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  },
);

const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(MaterialDashboard);
appInstance.mount("#app");
